<template>
  <div class="spe-search" :ddt-area="`component_${json.floorId}_搜索框组件`" ddt-expose="on">
    <div class="outer" :style="commonStyle" :class="{ fixed: fixed }">
      <div class="content">
        <!-- 全站搜索 -->
        <div class="st1" v-if="jdata.styleType == 1" >
          <i class="iconfont" v-if="jdata.info.showSearchIcon">&#xe65b;</i>
          <div class="word" v-if="jdata.info.showDefaultSearchWord && jdata.searchWord.length == 1" @click="openSearchPop(jdata.searchWord[0].word)">{{ jdata.searchWord[0].word }}</div>
          <div class="word" v-else-if="jdata.info.showDefaultSearchWord && jdata.searchWord.length > 1">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="(el, index) in jdata.searchWord" :key="index">
                <a
                  :data-area="pt()"
                  :data-pos="`component_${json.floorId}_搜索框组件.搜索框（全站搜索）_点击跳转`"
                  data-desc="打开搜索中间页"
                  :dd_name="`${pt()}.component_${json.floorId}_搜索框组件.搜索框（全站搜索）_点击跳转.打开搜索中间页`"
                  :ddt-click="`${pt()}.component_${json.floorId}_搜索框组件.搜索框（全站搜索）_点击跳转.打开搜索中间页`"
                  ddt-pit="搜索框（全站搜索）_点击跳转"
                  ddt-src="打开搜索中间页"
                  @click.stop="openSearchPop(el.word)"
                  style="color: #b6b6b6"
                >
                  <!--@click.stop="$sys.dict.href('search://key=' + el.word + '&cid=0')"-->
                  {{ el.word }}
                </a>
              </swiper-slide>
            </swiper>
          </div>
          <div
            class="word"
            v-else
            :data-area="pt()"
            :data-pos="`component_${json.floorId}_搜索框组件.搜索框（全站搜索）_点击跳转`"
            data-desc="打开搜索中间页"
            :dd_name="`${pt()}.component_${json.floorId}_搜索框组件.搜索框（全站搜索）_点击跳转.打开搜索中间页`"
            :ddt-click="`${pt()}.component_${json.floorId}_搜索框组件.搜索框（全站搜索）_点击跳转.打开搜索中间页`"
            ddt-pit="搜索框（全站搜索）_点击跳转"
            ddt-src="打开搜索中间页"
            ddt-expose="on"
            @click="openSearchPop('请输入商品/品牌/种类名称')"
          >请输入商品/品牌/种类名称</div>
        </div>
        <!-- 分类搜索 -->
        <div class="st2" v-else>
          <div class="l" @click="open = !open">
            <label>{{ jdata.sortList[current] && jdata.sortList[current].name }}</label>
            <span class="iconfont">&#xe675;</span>
          </div>
          <div class="c">
            <swiper ref="mySwiper" :options="swiperOptions" v-if="searchWordShow && jdata.searchWord">
              <swiper-slide v-for="(el, index) in jdata.searchWord" :key="index">
                <a
                  @click.stop="set_word_in_input(el.word)"
                  :ddt-src="el.word"
                  :data-area="pt()"
                  :data-pos="`component_${json.floorId}_搜索框组件.切换搜索关键词（分类搜索）_点击`"
                  :data-desc="el.word"
                  :dd_name="`${pt()}.component_${json.floorId}_搜索框组件.切换搜索关键词（分类搜索）_点击.${el.word}`"
                  :ddt-click="`${pt()}.component_${json.floorId}_搜索框组件.切换搜索关键词（分类搜索）_点击.${el.word}`"
                  ddt-pit="换搜索关键词（分类搜索）_点击"
                  ddt-expose="on"
                  style="color: #b6b6b6;"
                >
                  {{ el.word }}
                </a>
              </swiper-slide>
            </swiper>
            <input
              v-else
              :data-area="pt()"
              :data-pos="`component_${json.floorId}_搜索框组件.搜索框（分类搜索）_点击`"
              data-desc="打开搜索中间页"
              :dd_name="`${pt()}.component_${json.floorId}_搜索框组件.搜索框（分类搜索）_点击.打开搜索中间页`"
              :ddt-click="`${pt()}.component_${json.floorId}_搜索框组件.搜索框（分类搜索）_点击.打开搜索中间页`"
              ddt-pit="搜索框（分类搜索）_点击"
              ddt-src="打开搜索中间页"
              ddt-expose="on"
              ref="input"
              :placeholder="word"
              v-model="modelWord"
              @keyup.enter="to_search"
            />
          </div>
          <div class="r" v-show="clear_show" @click="word = ''">
            <span class="iconfont">&#xe6b2;</span>
          </div>

          <div class="sortlist" v-show="open">
            <div
              v-for="(el, index) in jdata.sortList"
              :key="index"
              @click="change(index)"
              :ddt-src="el.name"
              :data-area="pt()"
              :data-pos="`component_${json.floorId}_搜索框组件.修改分类（分类搜索）_点击`"
              :data-desc="el.name"
              :dd_name="`${pt()}.component_${json.floorId}_搜索框组件.修改分类（分类搜索）_点击.${el.name}`"
              :ddt-click="`${pt()}.component_${json.floorId}_搜索框组件.修改分类（分类搜索）_点击.${el.name}`"
              ddt-pit="修改分类（分类搜索）_点击"
              :data-src="el.name"
              ddt-expose="on"
            >
              {{ el.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import style (>= Swiper 6.x)
import "swiper/css/swiper.css";

export default {
  props: {
    json: {
      type: Object,
      default: () => {
        return {};
      }
    },
    pagebgcolor: ""
  },
  components: {
    Swiper,
    SwiperSlide
  },
  inject: ['pt'],
  data() {
    return {
      current: 0, //选中的分类
      open: false, //分类层是否展示
      word: "请输入商品/品牌/种类名称",
      searchWordShow: true, //分类搜索 搜索词和输入框切换
      fixed: false, //是否吸顶
      top: 0, //吸顶top
      modelWord:''
    };
  },
  computed: {
    jdata() {
      return this.json.data ||  { commonStyle: {}, info: {}, sortList: [] };
    },
    commonStyle() {
      let sty = {
        top: this.top + "px",
        padding: "0 " + this.jdata.commonStyle.margin + "px",
      };
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
      return sty;
    },
    clear_show() {
      if (this.word) {
        return true;
      } else {
        return false;
      }
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    swiperOptions() {
      let swiperOptions = {
        direction: "vertical",
        slidesPerView: 1,
        loop: true,
        autoplay:
          this.jdata.searchWord &&  this.jdata.searchWord.length >= 1 ? {
            delay: (this.jdata.info.rollTime || 1) * 1000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          } : false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren:true,
        // Some Swiper option/callback...
      };

      if( this.jdata.searchWord.length<=1 ){
        swiperOptions.loop=false
        swiperOptions.autoplay=false
      }

      return swiperOptions;
    }
  },
  watch: {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    window.onpageshow = function(event) {
      // console.log('page show')
      // console.log(this.swiper.slideNext);
      if (event.persisted) {
        if (this.swiper) {
          this.swiper.animating = false;
          this.swiper.slideNext();
        }
      }
    }.bind(this);
  },
  methods: {
    change(index) {
      this.current = index;
      this.open = false;
    },

    openSearchPop(word){
      let searchUrl	= this.json.data.searchUrl
      this.$emit('openSearchPopSend',{word,searchUrl})
      // $sys.dict.href('search://key=尾品汇&cid=0')
    },

    closeSearchPop(){
      this.$emit('closeSearchPopSend')
    },
    handleScroll() {
      if (!this.jdata.info.isFixedTop) {
        //如果设置不吸顶 就不计算位置
        this.fixed = this.jdata.info.isFixedTop
        return false;
      }
      //滚动条 滚动的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //获得search和lift组件的位置 然后来决定fixed的时候的位置
      let spesearch=document.querySelector('.spe-search')
      let search_index=(spesearch && spesearch.parentNode.getAttribute('data-index')) || -1
      let spelift=document.querySelector('.spe-lift')
      let lift_index=(spelift && spelift.parentNode.parentNode.getAttribute('data-index')) || -1

      //楼梯组件在页面的位置
      let offsetTop = spesearch.offsetTop;

      let top = 0; //吸顶距离顶部的高度

      //获得头部高度
      if (document.querySelector(".header_container.fixed")) {
        let h = document.querySelector(".ddheader").offsetHeight || 0;
        //滚动的位置 要减去 头部ddheader 高度
        offsetTop = offsetTop - h;
        top += h;
      }
      //获得楼梯组件高度
      if ( search_index > lift_index && document.querySelector(".spe-lift .fixed")) {
        let h = spelift.offsetHeight || 0;
        //滚动的位置 要减去 头部ddheader 高度
        offsetTop = offsetTop - h;
        top += h;
      }

      this.top = top;

      if (scrollTop >= offsetTop) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    },
    to_search() {
      if (this.modelWord) {
        let cid = this.jdata.sortList[this.current].path;
        let searchUrl	= this.json.data.searchUrl
        let sortUrl = searchUrl.replace('xxx', this.modelWord).replace('xxx',cid)
        this.$sys.dict.href(sortUrl);
      }else{
        if(this.word && this.word !== "请输入商品/品牌/种类名称"){
          let cid = this.jdata.sortList[this.current].path;
          let searchUrl	= this.json.data.searchUrl
          let sortUrl = searchUrl.replace('xxx', this.word).replace('xxx',cid)
          this.$sys.dict.href(sortUrl);
        }
      }
    },
    set_word_in_input(word) {
      this.word = word;
      this.searchWordShow = false;
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    }
  },
  filters: {},
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .spe-search {
    height: 120px;
    .outer {
      width: 750px;
      box-sizing: border-box;
      background-size: 100% 100%;
      background-position: left top;
      background-repeat: no-repeat;
      .content {
        padding: 24px;
        height: 72px;
        > div {
          height: 72px;
          background: #f5f5f5;
          border-radius: 40px;
          padding: 0 26px;
          display: flex;
          align-items: center;
        }
        .st1 {
          > i {
            font-size: 34px;
            color: #111111;
            margin-right: 14px;
          }
          > .word {
            flex: 1;
            font-size: 30px;
            color: #bebebe;
            .swiper-container {
              height: 72px;
              .swiper-slide {
                a {
                  display: flex;
                  align-items: center;
                  height: 100%;
                }
              }
            }
          }
        }
        .st2 {
          position: relative;
          .l {
            margin-right: 24px;
            > label {
              font-size: 30px;
              color: #141414;
              margin-right: 16px;
            }
            .iconfont {
              font-size: 16px;
              color: #141414;
            }
          }
          .c {
            flex: 1;
            height: 72px;
            .swiper-container {
              height: 72px;
              .swiper-slide {
                display: flex;
                a {
                  display: flex;
                  align-items: center;
                  height: 100%;
                  flex: 1;
                }
              }
            }
            > input {
              height: 72px;
              width: 100%;
              background: none;
              &::-webkit-input-placeholder { /* WebKit browsers */
                color: #b6b6b6;
              }
              &::-moz-placeholder { /* Mozilla Firefox 19+ */
                color: #b6b6b6;
              }
              &::-ms-input-placeholder { /* Internet Explorer 10+ */
                color: #b6b6b6;
              }
            }
          }
          .r {
            width: 32px;
            .iconfont {
              font-size: 32px;
              color: #aaaaaa;
            }
          }
          .sortlist {
            background: #ffffff;
            border-radius: 8px;
            // width: 330px;
            // height: 356px;
            padding: 0 20px 26px 20px;
            position: absolute;
            top: 72px;
            left: 0;
            font-size: 30px;
            color: #141414;
            > div {
              margin-top: 26px;
            }
          }
        }
      }
    }
    .fixed {
      position: fixed;
      left: auto;
      right: auto;
      top: 89px;
      z-index: 2;
    }
  }
</style>
